import { Box, Button, IconButton, Tooltip } from '@mui/material'
import BlockIcon from '@mui/icons-material/Block'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'
import { InfoMensajeMobile } from '../../../components/mobile/InfoMensajeMobile'
import { HeaderProps } from '../../OperacionLayout'
import { MensajeDetalleFields } from 'src/pages/messages/types'

const permiteAnular = (value: unknown) => value === true || value === 1 || value === '1' || value === 'true'

export const HeaderMobile = ({ acciones, message }: HeaderProps) => {
    const { cancelHandler, closeHandler, printHandler } = acciones
    const puedeAnular =
        permiteAnular(message[MensajeDetalleFields.PermiteAnular]) ||
        permiteAnular(message[MensajeDetalleFields.PermiteAnularAlias])
    const puedeDescargarInforme = !!printHandler

    return (
        <>
            <InfoMensajeMobile message={message} />
            <Box display='flex' alignItems='center' gap={1}>
                {puedeDescargarInforme && printHandler && (
                    <Tooltip title='Descargar'>
                        <IconButton onClick={printHandler}>
                            <DownloadIcon color='primary' />
                        </IconButton>
                    </Tooltip>
                )}
                {puedeAnular && (
                    <Tooltip title='Anular'>
                        <Button size='small' variant='outlined' color='error' startIcon={<BlockIcon />} onClick={cancelHandler}>
                            Anular
                        </Button>
                    </Tooltip>
                )}
                {closeHandler && (
                    <Tooltip title='Cerrar'>
                        <IconButton onClick={closeHandler}>
                            <CloseIcon color='primary' />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </>
    )
}
